// extracted by mini-css-extract-plugin
export var discard = "_21-4";
export var muiTooltipTooltip = "_21-6";
export var notificationBar = "_21-3";
export var notificationContainer = "_21-2";
export var saveButtonHoverSlotWrapper = "_21-5";
export var show = "_21-1";
export var spacer = "_21-0";